import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { MfsLimitedAccessConfig } from '@common/models/mfs-limited-access-config';

@Injectable()
export class MfsLimitedAccessConfigService {

  constructor(private http: HttpClient, private readonly urlBuilderService: UrlBuilderService) { }

  get(): Observable<MfsLimitedAccessConfig> {
    const url = this.urlBuilderService.getUrl('mfs/limitedaccessconfig');

    return this.http
      .get<MfsLimitedAccessConfig>(url).pipe(
        map(config => config || undefined)
      );
  }
}
